import axios from 'axios'
import { config } from "../Config/config"

const statusOnlineDoctor = {
    getAll: () => {
        const result = axios.get(config.apiUrl + '/Doctor_jadwal')
        //ketika berhasil 
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        //untuk pesan errornya
        .catch(error => {
            return {
                success : false,
                error : error
            }
        })
        return result
    },
    

}

export default statusOnlineDoctor